<template>
  <div>
    <common-dialog
      ref="dialog"
      width="600px"
      show-save-button
      id-key="ExamStudentId"
      title="参加报名学生"
      edit-title
      :data="data"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      close-on-saved
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      :before-save="onBeforeSave"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="考场号" prop="ExamHallNo">
              <el-input v-model="data.ExamHallNo" placeholder="请输入考场号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="座位号" prop="SeatNo">
              <el-input v-model="data.SeatNo" placeholder="请输入座位号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="准考证号" prop="AdmissionNo">
              <el-input v-model="data.AdmissionNo" placeholder="请输入准考证号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="报名学生" prop="MemberId">
              <el-input v-model="data.FullName" @focus="selectSt" placeholder="点击选择"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <st-dialog ref="stDialog" in-dialog selectable @select="setSt" />
      <st-dialog2 ref="stDialog2" in-dialog selectable @select="setSt" />
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import stDialog from "@/components/po/poreport/6/listDialog";
import stDialog2 from "@/components/po/poreport/9/listDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    stDialog,
    stDialog2
  },
  props: {
    examId: {
      type: Number,
      default: 0,
    },
    type: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      data: {
        ExamStudentId: 0,
        ExamId: 0,
        ExamHallNo: "",
        SeatNo: "",
        AdmissionNo: "",
        FullName: "",
        MemberType: 0,
        MemberId: null,
      },
      isMB: this.$store.state.isMB,
      api: require("@/api/po/examstudent").default,
      sixApi: require("@/api/po/junior6").default,
      nineApi: require("@/api/po/junior9").default,
      rules: {
        ExamHallNo: [{ required: true, message: "请输入考场号" }],
        SeatNo: [{ required: true, message: "请输入座位号" }],
        AdmissionNo: [{ required: true, message: "请输入准考证号" }],
        MemberId: [{ required: true, message: "请选择学生" }],
      },
    };
  },
  methods: {
    onCreateOpened() {
      
    },
    onEditOpened(data) {
      
    },
    selectSt() {
      if(this.type == 0) {
        this.$refs.stDialog.open().then((that) => {
          that.getData({ Status: 3, Statuses: [], FileStatus:0  });
        });
      } else {
        this.$refs.stDialog2.open().then((that) => {
          that.getData({ Status: 3, Statuses: [], FileStatus:0  });
        });
      }
    },
    setSt(e) {
      if(this.type == 0) {
        this.data.MemberId = e.Junior6Id;
        this.data.FullName = e.FullName;
      } else {
        this.data.MemberId = e.Junior9Id;
        this.data.FullName = e.FullName;
      }
    },
    onBeforeSave() {
      this.data.ExamId = this.examId;
      this.data.MemberType = this.type;
    },
    onClosed() {
      
    },
  }
};
</script>